import type { Meta, StoryObj } from "@storybook/react";

import type { LabelWithIconProps } from "@/ui/core";
import { FAIconName, LabelWithIcon } from "@/ui/core";
import { ColorToken } from "@/ui/theme/tokens";

const StoryMeta: Meta<LabelWithIconProps> = {
  title: "Core/Label With Icon",
  component: LabelWithIcon,
  argTypes: {
    iconColor: {
      control: "select",
      options: Object.values(ColorToken),
    },
    iconName: {
      control: "select",
      options: Object.values(FAIconName),
    },
    text: { control: "text" },
  },
  args: {
    iconColor: ColorToken.Primary100,
    iconName: FAIconName.Check,
    text: "Placeholder text",
  },
};

type Story = StoryObj<LabelWithIconProps>;

export const Primary: Story = {};
export default StoryMeta;
